<template>
  <!-- START : Account edit page -->
  <div class="w-100">
    <WCSpinner v-if="loading" size="xl" position="center" />
    <div class="wc-account-form" v-else>
      <!-- Dynamically render the form component based on route-->
      <component
        :is="renderComponent"
        :me="me"
        @formChanged="processformUpdate"
        @formUpdateValid="formSave"
      />
      <button
        class="btn btn-primary w-100 my-3 save-btn"
        @click="save(me)"
        :disabled="!isFormValid"
      >
        {{ $t('save') }}
      </button>
    </div>
  </div>
  <!-- END : Account edit page -->
</template>

<script>
/* eslint-disable func-names */
import { ACCOUNT_SETTINGS_ROUTE_CMP_MAP } from '@/constants/AppConstants';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import axios from 'axios';
import MeService from '@/services/me.service';
import WCProfileInfoSectionForm from '@/modules/user/components/WCProfileInfoSectionForm/WCProfileInfoSectionForm.vue';
import WCWorkInfoSectionForm from '@/modules/user/components/WCWorkInfoSectionForm/WCWorkInfoSectionForm.vue';
import WCOtherInfoSectionForm from '@/modules/user/components/WCOtherInfoSectionForm/WCOtherInfoSectionForm.vue';
import WCEmailInfoSectionForm from '@/modules/user/components/WCEmailInfoSectionForm/WCEmailInfoSectionForm.vue';
import WCPhoneInfoSectionForm from '@/modules/user/components/WCPhoneInfoSectionForm/WCPhoneInfoSectionForm.vue';
import WCAddressInfoSectionForm from '@/modules/user/components/WCAddressInfoSectionForm/WCAddressInfoSectionForm.vue';
import AccountSettingsMixin from '@/modules/user/mixins/AccountSettingsMixin';

export default {
  name: 'MobileAccountEdit',
  components: {
    WCSpinner,
    WCProfileInfoSectionForm,
    WCWorkInfoSectionForm,
    WCOtherInfoSectionForm,
    WCEmailInfoSectionForm,
    WCPhoneInfoSectionForm,
    WCAddressInfoSectionForm,
  },
  mixins: [AccountSettingsMixin], // Mixin for save, processUpdate, formSave, isFormValid and onFormComplete
  async mounted() {
    try {
      this.loading = true;
      const meResponse = await axios.get('api/me');
      this.me = meResponse.data;
      this.form.prefix = this.me.prefix && this.me.prefix.value;
      this.form.firstName = this.me.firstName && this.me.firstName.value;
      this.form.middleName = this.me.middleName && this.me.middleName.value;
      this.form.lastName = this.me.lastName && this.me.lastName.value;
      this.form.suffix = this.me.suffix && this.me.suffix.value;
      this.form.nickname = this.me.nickname && this.me.nickname.value;
      this.form.birthDate = this.me.birthDate && this.me.birthDate.value;
      this.form.company = this.me.company && this.me.company.value;
      this.form.title = this.me.title && this.me.title.value;
      this.form.pf1 = this.me.pf1 && this.me.pf1.value;
      this.form.pf2 = this.me.pf2 && this.me.pf2.value;
      this.form.pf3 = this.me.pf3 && this.me.pf3.value;
      this.form.pf4 = this.me.pf4 && this.me.pf4.value;
      this.form.pf5 = this.me.pf5 && this.me.pf5.value;
      this.form.pf6 = this.me.pf6 && this.me.pf6.value;
      this.form.pf7 = this.me.pf7 && this.me.pf7.value;
      this.form.pf8 = this.me.pf8 && this.me.pf8.value;
      this.form.suppressReceipt = this.me.suppressReceipt && this.me.suppressReceipt.value;
      this.form.phones = this.me.phones;
      this.form.emails = this.me.emails;
      this.form.addresses = this.me.addresses;

      this.meService = new MeService();
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
  watch: {
    onFormComplete() {
      if (this.onFormComplete) {
        this.$router.push({
          name: 'Account Settings',
        });
      }
    },
  },
  computed: {
    /**
     * Based on route param, get the component to render
     */
    renderComponent() {
      const settingComp = ACCOUNT_SETTINGS_ROUTE_CMP_MAP[this.$route.params.id];
      return settingComp ? settingComp.component : 'error';
    },
  },
  data() {
    return {
      me: {},
      loading: false,
      form: {
        prefix: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        nickname: '',
        birthDate: '',
        company: '',
        title: '',
        pf1: '',
        pf2: '',
        pf3: '',
        pf4: '',
        pf5: '',
        pf6: '',
        pf7: '',
        pf8: '',
        suppressReceipt: false,
        phones: [],
        emails: [],
        addresses: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-account-form {
  padding: 1rem;
}
</style>
